import { lensPath } from 'ramda';
import * as RA from 'ramda-adjunct';

export const DataLens = (...args) => lensPath(['data', ...args]);
export const viewData = (defaultValue, ...args) => RA.viewOr(defaultValue, lensPath(['data', ...args]));
